import React from 'react';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  bgColor?: 'ivory' | 'sand' | 'charcoal' | 'plum-deep' | 'white';
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  bgColor = 'ivory',
  id
}: SectionWrapperProps) {
  const bgColors = {
    ivory: 'bg-ivory',
    sand: 'bg-sand',
    charcoal: 'bg-charcoal',
    'plum-deep': 'bg-plum-deep',
    white: 'bg-white'
  };
  return <section id={id} className={`w-full py-12 md:py-16 ${bgColors[bgColor]} ${className} relative`} data-id="element-239">
      <div className="mx-auto px-6 max-w-[480px]" data-id="element-240">{children}</div>
    </section>;
}